exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-44edbfab] {\n  width: 100%;\n  margin-top: 1rem;\n}", ""]);

// exports
